interface Props {
  text: string;
  className?: string;
}

export default function SectionLabel({ text, className }: Props) {
  return (
    <div className={`flex items-center gap-2 ${className ?? ""}`.trim()}>
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          background: "#D4A843",
          display: "inline-block",
          flexShrink: 0,
        }}
      />
      <span
        style={{
          fontFamily: "'Barlow Condensed', sans-serif",
          fontWeight: 700,
          fontSize: 11,
          letterSpacing: "0.3em",
          color: "#D4A843",
          textTransform: "uppercase",
        }}
      >
        {text}
      </span>
    </div>
  );
}
